import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export const createTag = ({ value, type }) => {
  const sql = `
    mutation createTag(
         $input: CreateTagInput!
         ){
            createTag(input: $input) { 
              id
              value
              type
            }
        }
    `

  const params = { input: { value, type } }
  return callAuthorizedGraphQLEndpoint(sql, params)
}
